import { Box, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { muiTheme } from "@/styles/theme";
import useLeadContactMethods from "@/modules/lead-page/hooks/lead-info/lead-contact-methods.hook";
import { normalizeContactPhone } from "@/modules/common/utils/customer-contact";

const SearchTruecaller = ({ phoneNumber }: { phoneNumber?: string }) => {
  const { handleSearchTruecaller } = useLeadContactMethods();
  const disabled = phoneNumber !== undefined && !normalizeContactPhone(phoneNumber);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        alignItems: "center",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
      }}
      role="button"
      aria-disabled={disabled}
      title={disabled ? "Phone number unavailable" : "Search Truecaller"}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(event) => {
        if (!disabled && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          handleSearchTruecaller(phoneNumber);
        }
      }}
      onClick={() => { if (!disabled) handleSearchTruecaller(phoneNumber); }}
    >
      <Typography
        variant="h5_med"
        sx={{
          color: muiTheme.colorSchemes.light.palette.main.actionBlue,
        }}
      >
        True Caller
      </Typography>
      <SearchOutlinedIcon
        sx={{
          color: muiTheme.colorSchemes.light.palette.main.actionBlue,
        }}
      />
    </Box>
  );
};

export default SearchTruecaller;
